import { Star } from 'lucide-react';
import { apiErrorMessage, apiFetch, v1Path } from '../../lib/api';
import { isProjectId } from '../../lib/project-path';
import { useSession } from '../session-context';
import { cn } from '../../lib/utils';
import { useOverlays } from './overlay-context';

export default function StarProjectButton({
  projectId,
  className,
}: {
  projectId: string;
  className?: string;
}) {
  const { starredProjectId, reload } = useSession();
  const { toast } = useOverlays();
  const starred = starredProjectId === projectId;

  async function toggle(): Promise<void> {
    if (!isProjectId(projectId)) {
      toast('Invalid stream.');
      return;
    }
    try {
      await apiFetch(v1Path('/me'), {
        method: 'PATCH',
        body: JSON.stringify({ starred_project_id: starred ? null : projectId }),
      });
      await reload();
    } catch (err) {
      toast(apiErrorMessage(err, 'Could not update starred stream.'));
    }
  }

  return (
    <button
      type="button"
      aria-pressed={starred}
      aria-label={
        starred
          ? 'Stop opening this stream when you sign in'
          : 'Open this stream when you sign in'
      }
      className={cn(
        'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-sm text-muted-foreground hover:text-foreground',
        starred && 'text-foreground',
        className,
      )}
      onPointerDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        void toggle();
      }}
    >
      <Star className={starred ? 'fill-current' : undefined} aria-hidden />
    </button>
  );
}
